<template>
  <div class="sensitive-word">
    <sensitiveTopBar
      ref="topBar"
      :options="options"
      @selectType="selectType"
      @addShow="addShowType"
      @creator="creator"
      @editShow="editShowType"
      @checkAllType="checkAllType"
      @delbatch="delbatch"
      :batchBtnShowType="batchBtnShow"
      :cancelBtnShowType="cancelBtnShow"
      @getPageNum="getPageNum"
      @search="search"
    />
    <sensitiveWordItem
      :sensitiveWordData="sensitiveWordData"
      :getListResult="getListResult"
      :pageSize="pageSize"
      @pageNum="getPageNum"
      @pageSize="pageSizeChange"
      :total="total"
      :editShow="editShow"
      @reviseShowType="reviseShowType"
      @reviseWord="reviseWords"
      @delWords="delWords"
      :checkAll="checkAll"
      @deleteBatchList="deleteBatchList"
    />
    <!-- 添加敏感词弹出框 -->
    <sensitiveWordAdd
      :options="options"
      :dialogVisible.sync="addShow"
      v-show="addShow"
    />
    <!-- 修改敏感词弹出框 -->
    <sensitiveWordRevise
      :options="options"
      :dialogVisible.sync="reviseShow"
      v-show="reviseShow"
      :reviseWord="reviseWord"
    />
  </div>
</template>

<script>
import sensitiveTopBar from "./components/sensitiveWord-topbar/sensitiveWord-topbar.vue";
import sensitiveWordItem from "./components/sensitiveWord-item/sensitiveWord-item.vue";
import sensitiveWordAdd from "./components/sensitiveWord-add/sensitiveWord-add.vue";
import sensitiveWordRevise from "./components/sensitiveWord-revise/sensitiveWord-revise.vue";

export default {
  name: "sensitive-word",
  data() {
    return {
      options: [],
      pageSize: 100, // 每页条数
      pageNum: 1, // 当前页码
      total: 0, // 总条数
      sensitiveWordData: [],
      getListResult: "nullData",
      classify: "",
      addShow: false,
      reviseShow: false,
      editShow: "",
      reviseWord: {},
      checkAll: false, //
      deleteBatchLists: [], // 批量删除列表
      delArr: [],
      batchBtnShow: false,
      cancelBtnShow: false,
      word: "",
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getType();
    this.getSensitiveWordData();
  },
  methods: {
    // 搜索
    search(e) {
      this.word = e;
      this.getSensitiveWordData();
    },
    // 批量删除
    delbatch(e) {
      if (!this.delArr.length) {
        return this.$message.warning("请先选择需要删除的敏感词");
      }
      this.$confirm("是否删除选中的敏感词?", "删除敏感词", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(this.$url.delWords, {
            schoolId: this.user.schoolId,
            dataList: this.delArr,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200 && res.data != 0) {
                this.$message.success(res.msg);
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error(res.msg);
            });
        })
        .catch(() => {});
    },
    // 批量删除列表
    deleteBatchList(e) {
      this.delArr = e;
    },
    // 全选
    checkAllType(e) {
      this.checkAll = e;
    },
    // 单个删除关键字
    delWords(e) {
      this.delArr = [];
      this.delArr.push(e.id);
      this.delete(this.$url.delWords, {
        schoolId: this.user.schoolId,
        dataList: this.delArr,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200 && res.data != 0) {
            this.$message.success(res.msg);
            // 刷新列表
            this.refresh();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err);
          this.$message.error(res.msg);
        });
    },
    // 修改的敏感字
    reviseWords(e) {
      // console.log(e);
      this.reviseWord = e;
    },
    // 敏感字状态管理
    editShowType(e) {
      this.sensitiveWordData.map((item) => {
        if (item.schoolId == this.user.schoolId) {
          item.remark = e;
          return;
        }
        item.remark = " ";
      });
    },
    // 创建者{
    creator(e) {
      this.schoolId = e == "全部" ? "" : this.user.schoolId;
      this.sensitiveWordData = null;
      this.getSensitiveWordData();
    },
    // 添加框显示
    addShowType(e) {
      // console.log(e);
      this.addShow = e;
    },
    reviseShowType(e) {
      this.reviseShow = e;
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.sensitiveWordData = [];
      this.getSensitiveWordData();
      this.$refs.topBar.batchBtnShow = false;
      this.$refs.topBar.cancelBtnShow = false;
    },
    // 分页
    getPageNum(e) {
      this.pageNum = e;
      // 给按钮显示赋予会动态变化的分页数字，以起到监听赋值的作用
      this.batchBtnShow = e;
      this.cancelBtnShow = e;
    },
    pageSizeChange(e) {
      this.pageSize = e;
      // 给按钮显示赋予会动态变化的分页数字，以起到监听赋值的作用
      // this.batchBtnShow = e;
      // this.cancelBtnShow = e;
      this.getSensitiveWordData();
    },
    // 分类
    selectType(e) {
      if (e == "全部") {
        this.classify = "";
        this.sensitiveWordData = null;
        this.getSensitiveWordData();
        return;
      }
      this.classify = e;
    },
    // 获取敏感词
    getSensitiveWordData() {
      this.post(this.$url.queryWords, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolId: this.user.schoolId,
        word: this.word,
        type: this.classify,
      })
        .then((res) => {
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error("获取敏感字审批列表失败！");
            return;
          }
          this.sensitiveWordData = res.rows;
          this.total = res.total;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 获取敏感词类型
    getType() {
      this.get(this.$url.selectSensitiveWordsType).then((res) => {
        this.options = res.data;
        this.options.unshift("全部");
        // console.log(this.options);
      });
    },
  },
  watch: {
    // 状态切换
    classify: {
      handler(val) {
        if (val) {
          // console.log("watch=>",val);
          this.sensitiveWordData = null;
          this.getSensitiveWordData();
        }
      },
      immediate: true,
    },
    pageNum: {
      handler(val) {
        if (val) {
          this.sensitiveWordData = null;
          this.getSensitiveWordData();
        }
      },
      immediate: true,
    },
  },
  components: {
    sensitiveTopBar,
    sensitiveWordItem,
    sensitiveWordAdd,
    sensitiveWordRevise,
  },
};
</script>

<style lang="scss" scoped>
@import "./sensitiveWord.scss";
</style>